import {observable} from 'mobx';


class Dialog {
  @observable open = false;
  @observable title = '';
  @observable content = '';
  @observable result = false;
  message(title,content){
    this.open = true;
    this.title = title;
    this.content = content;
  }
  default(){
    this.open = false;
    this.title = '';
    this.content = '';
  }
  handleClose(){
    this.open=false;
  }
  handleOpen(){
    this.open=true;
  }
}
var dialog = new Dialog;

export default dialog;



// WEBPACK FOOTER //
// ./src/store/dialog.js